<div class="headerdiv">
    <div >
      <h3 class="pagetitle">Ads</h3>
      <label class="settings"><a>Settings</a> | <a>Analytics</a> </label>
    </div>
  
  </div>
  
  <mat-card [formGroup]="adForm" class="addadmin">
      <label class="inviteuser">Create Advertisement</label>
  <div class="row">
      <div class="col d-flex justify-content-center">
        <mat-form-field appearance="outline">
            <input matInput placeholder="Name" formControlName="name">
          </mat-form-field>
      </div>
      <div class="col d-flex justify-content-center">
        <mat-form-field appearance="outline">
            <input matInput placeholder="Description" formControlName="description">
          </mat-form-field>
      </div>
      <div class="col d-flex justify-content-center">
        <mat-form-field appearance="outline">
            <input matInput placeholder="Redirection URL" formControlName="url">
          </mat-form-field>
      </div>
      <div class="col d-flex justify-content-center">
        <mat-form-field appearance="outline">
            <input matInput placeholder="Number of Days" formControlName="duration">
          </mat-form-field>
      </div>
      <!-- <div class="col d-flex justify-content-center">
      <form class="countryselection" [formGroup]="countryFormGroup">
        <mat-select-country appearance="outline" [countries]="predefinedCountries" label="" formControlName="country"
          (onCountrySelected)="onCountrySelected($event)">
        </mat-select-country>
      </form>
      </div> -->
      <div class="col d-flex justify-content-center">
        <!-- <mat-form-field appearance="outline">
            <input matInput placeholder="Country" formControlName="country">
          </mat-form-field> -->
          <!-- <form [formGroup]="countryFormGroup">
            <mat-select-country appearance="outline" [countries]="predefinedCountries" label="" formControlName="country"
            (onCountrySelected)="onCountrySelected($event)"
                >
            </mat-select-country>
        </form> -->
      </div>
      

  </div>
  <div class="col d-flex justify-content-center">
    <div style="margin-top: 20px ;">

      <span (click)="fileInput.click()" class="material-icons" style="color: #5d2041;">
        cloud_upload
      </span>
      <label (click)="fileInput.click()" class="uploadimagetext">Upload Image*</label>
      <br>
      <i matTooltip="For a better resolution, we recommend uploading a square picture">Recommended ratio 1:1</i>

      <!-- <input #fileInput type="file" (change)="selectFile($event)" style="display:none;" /> -->
      <input 
      

      #fileInput type="file" (change)="selectFile($event)" style="display:none;" ng2FileSelect
        [uploader]="uploader" />

      <div [innerHtml]='msg' *ngIf="msg" style="color: red;"></div>
      <div>
        <img class="uploadedimage" [src]="url" *ngIf="url"></div>

    </div>
  </div>
  <button (click)="createAd()" mat-flat-button color="accent">Create</button>
</mat-card>



<div style="font-size: 10px" class="container tablecontainer">
  <div class="row">

    <div class="search">
      <label for="search">Search for Admin Advertisment</label>

      <div class="md-form">
        <input style="border: 1px solid #5d2041;"
          type="text"
          [(ngModel)]="searchText"
          class="form-control"
          id="search"
          mdbInput
        />
      </div>
    </div>
  </div>

  <table mdbTable #eventsTable="mdbTable" class="z-depth-1">
    <thead style="background-color: #5d2041; color: white;">
      <tr>
        <th
          *ngFor="let head of headElements; let i = index"
          aria-controls="tableSortExample" 
          scope="col" 
          [mdbTableSort]="adsList" 
          [sortBy]="headElements[i]"
        >
          {{head | titlecase}}
        </th>
        
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let el of adsList; let i = index">
        <th *ngIf="i+1 >= mdbTablePagination.firstItemIndex && i < mdbTablePagination.lastItemIndex"
          scope="row" routerLink='/admin/detailedad' (click)="saveAd(el)">{{el.name}}</th>
          
        <td *ngIf="i+1 >= mdbTablePagination.firstItemIndex && i < mdbTablePagination.lastItemIndex">
          <img style="width: 150px;" src="{{'https://events.globalistic.tech/'+ el.image}}" /></td>
        <td *ngIf="i+1 >= mdbTablePagination.firstItemIndex && i < mdbTablePagination.lastItemIndex">{{el.description}}</td>
        <td *ngIf="i+1 >= mdbTablePagination.firstItemIndex && i < mdbTablePagination.lastItemIndex">{{el.url}}</td>
        <td *ngIf="i+1 >= mdbTablePagination.firstItemIndex && i < mdbTablePagination.lastItemIndex">{{el.duration}} days</td>
        <!-- <td *ngIf="i+1 >= mdbTablePagination.firstItemIndex && i < mdbTablePagination.lastItemIndex">{{el.country}}</td> -->
        <td *ngIf="i+1 >= mdbTablePagination.firstItemIndex && i < mdbTablePagination.lastItemIndex">{{el.status}}</td>
        <td *ngIf="i+1 >= mdbTablePagination.firstItemIndex && i < mdbTablePagination.lastItemIndex">
          <button *ngIf="el.status!= active" mat-flat-button color="primary" (click)="activateId(el.id)">Activate</button>
          <button *ngIf="el.status== active" mat-flat-button color="primary" (click)="activateId(el.id)">Deactivate</button>
          <button mat-flat-button color="primary" (click)="showCancellation(el.id)"> Delete</button>
        </td>
        

      </tr>
        <td colspan="4">
          <mdb-table-pagination [tableEl]="eventsTable" [searchDataSource]="adsList"></mdb-table-pagination>
        </td>
    </tbody>
  </table>
</div>

<app-user-ads></app-user-ads>

 <!-- Cancellation Reason Modal -->
  
 <div [style.display]="cancellationReason ? 'block' : 'none'" class="modal" id="imagemodal" tabindex="-1" role="dialog"
 aria-labelledby="myModalLabel" aria-hidden="true">
 <div class="modal-dialog">
   <div class="modal-content">
     <div class="modal-header">
       <h4 class="modal-title" id="myModalLabel">Delete Ad</h4>
       <i style="cursor: pointer;" style="transform: scale(2);" data-dismiss="modal" (click)="hideCancellation()"
         class="material-icons">highlight_off</i>

     </div>
     <div style="display: inline-block;">

       <div class="modal-body">
        
         <mat-label>Are you sure you want to delete this ad?</mat-label>

         <button  (click)="deleteId()" class="confirmcancellation">Confirm</button>
       </div>
       <div class="modal-footer">

       </div>
     </div>
   </div>
 </div>
</div>